import React from 'react';
import { ArrowRight } from 'lucide-react';
export function EmployerSolutions() {
  return <section className="py-24 px-6 md:px-12 bg-gray-50" data-id="element-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
        {/* Content */}
        <div className="order-2 lg:order-1" data-id="element-14">
          <div className="section-badge" data-id="element-15">LABOR SOLUTIONS</div>
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-6 leading-tight" data-id="element-16">
            SKILLED LABOR SOLUTIONS{' '}
            <span className="text-primary" data-id="element-17">FOR EMPLOYERS</span>
          </h2>
          <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-18">
            BND Contracting understands the critical importance of having a
            reliable, skilled workforce. We provide comprehensive staffing
            solutions tailored to the unique demands of the Gulf Coast
            industrial sector. From temporary supplemental labor to long-term
            project staffing, we deliver the right personnel to keep your
            operations running smoothly and safely.
          </p>
          <button className="btn-white border border-gray-200 shadow-sm w-fit group" data-id="element-19">
            LEARN MORE
            <div className="bg-primary text-white rounded-full p-1 group-hover:bg-primary-hover transition-colors" data-id="element-20">
              <ArrowRight size={16} data-id="element-21" />
            </div>
          </button>
        </div>

        {/* Image with offset border */}
        <div className="relative pr-6 pb-6 order-1 lg:order-2" data-id="element-22">
          {/* Blue offset border (bottom right) */}
          <div className="absolute bottom-0 right-0 w-[90%] h-[90%] border-8 border-primary z-0" data-id="element-23"></div>
          <img src="https://images.unsplash.com/photo-1587293852726-70cdb56c2866?q=80&w=1000&auto=format&fit=crop" alt="Industrial facility" className="relative z-10 w-full h-[500px] object-cover shadow-xl" data-id="element-24" />
        </div>
      </div>
    </section>;
}